import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Pages.css';

function Services({ user, apiUrl, token }) {
  const navigate = useNavigate();
  const isClient = !user || (user.role !== 'practitioner' && user.role !== 'admin');
  const [services, setServices] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    duration_minutes: 60,
    price: 0
  });
  const [error, setError] = useState('');

  useEffect(() => {
    fetchServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchServices = async () => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(`${apiUrl}/services`, { headers });
      setServices(response.data);
    } catch (err) {
      setError('Failed to fetch services');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'price' || name === 'duration_minutes' ? parseFloat(value) : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.post(`${apiUrl}/services`, formData, { headers });
      setFormData({
        name: '',
        description: '',
        duration_minutes: 60,
        price: 0
      });
      setShowForm(false);
      fetchServices();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create service');
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Services</h1>
        {user?.role === 'practitioner' && (
          <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
            {showForm ? 'Cancel' : '+ Add Service'}
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && user?.role === 'practitioner' && (
        <div className="card">
          <h2>Create New Service</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Service Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="e.g., Tarot Reading"
              />
            </div>

            <div className="form-group">
              <label>Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="4"
                placeholder="Describe your service..."
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Duration (minutes)</label>
                <input
                  type="number"
                  name="duration_minutes"
                  value={formData.duration_minutes}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Price ($)</label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  step="0.01"
                  required
                />
              </div>
            </div>

            <button type="submit" className="btn btn-primary">Create Service</button>
          </form>
        </div>
      )}

      <div className="services-grid">
        {services.length > 0 ? (
          services.map(service => (
            <div
              key={service.id}
              className="service-card"
              onClick={isClient ? () => navigate('/booking', { state: { serviceId: service.id } }) : undefined}
              style={isClient ? undefined : { cursor: 'default' }}
            >
              <h3>{service.name}</h3>
              {service.practitioner_name && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                  {service.practitioner_photo && (
                    <img
                      src={`${apiUrl}/uploads/profiles/${service.practitioner_photo}`}
                      alt={service.practitioner_name}
                      style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover' }}
                    />
                  )}
                  <span className="text-muted" style={{ fontSize: '0.85rem' }}>with {service.practitioner_name}</span>
                </div>
              )}
              <p className="service-description">{service.description}</p>
              {service.practitioner_bio && (
                <p className="text-muted" style={{ fontSize: '0.8rem', fontStyle: 'italic' }}>{service.practitioner_bio}</p>
              )}
              <div className="service-details">
                <span className="duration">⏱ {service.duration_minutes} min</span>
                <span className="price">💰 ${service.price}</span>
              </div>
            </div>
          ))
        ) : (
          <p className="empty-state">No services available yet.</p>
        )}
      </div>
    </div>
  );
}

export default Services;
